/**
 * @brisa/ui · Badge
 *
 * Pill de status com 4 tones (default / success / warning / danger).
 */
import * as React from 'react';

export type BadgeTone = 'default' | 'success' | 'warning' | 'danger';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { tone = 'default', className, children, ...rest },
  ref,
) {
  const classes = [
    'brisa-badge',
    'brisa-pill',
    tone === 'default' && 'brisa-badge--default',
    tone === 'success' && 'brisa-badge--success brisa-badge--verde',
    tone === 'warning' && 'brisa-badge--warning brisa-badge--lilas',
    tone === 'danger' && 'brisa-badge--danger brisa-badge--critical',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span ref={ref} className={classes} role="status" {...rest}>
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';
